import { AddPetCareModal } from './AddPetCareModal/AddPetCareModal';
import { BookingAgencySuccessModal } from './BookingAgencySuccessModal/BookingAgencySuccessModal';
import { BookingRecurringSuccessModal } from './BookingRecurringSuccessModal/BookingRecurringSuccessModal';
import { CropperModal } from './CropperModal/CropperModal';
import { IdentityVerificationModal } from './IdentityVerificationModal/IdentityVerificationModal';

enum ModalName {
  AddPetCare = 'AddPetCare',
  BookingAgencySuccess = 'BookingAgencySuccess',
  BookingRecurringSuccess = 'BookingRecurringSuccess',
  Cropper = 'Cropper',
  IdentityVerification = 'IdentityVerification',
  SavedSearch = 'SavedSearch',
};

const modalConfig: Partial<Record<ModalName, { modal: () => JSX.Element; classes: string }>> = {
  [ModalName.AddPetCare]: {
    modal: AddPetCareModal,
    classes: 'border-2 border-neutral-200 rounded-md bg-white xs:w-full md:w-2/5 overflow-x-hidden overflow-y-auto relative top-20 mx-auto',
  },
  [ModalName.BookingAgencySuccess]: {
    modal: BookingAgencySuccessModal,
    classes: 'border-2 border-neutral-200 bg-white p-5 md:w-[620px] md:top-20 rounded-2xl overflow-y-auto relative mx-auto',
  },
  [ModalName.BookingRecurringSuccess]: {
    modal: BookingRecurringSuccessModal,
    classes: 'border-2 border-neutral-200 bg-white p-5 md:w-[620px] md:top-20 rounded-2xl overflow-y-auto relative mx-auto',
  },
  [ModalName.Cropper]: {
    modal: CropperModal,
    classes: 'border-2 border-neutral-200 p-5 rounded-md bg-white w-[90%] md:w-1/2 lg:w-2/5 overflow-x-hidden overflow-y-auto relative top-20 xs:top-40 mx-auto z-50',
  },
  [ModalName.IdentityVerification]: {
    modal: IdentityVerificationModal,
    classes: 'border-2 bg-white p-4 h-full md:h-auto md:w-[620px] md:top-20 rounded-2xl overflow-y-auto relative mx-auto',
  }
};

export { modalConfig, ModalName };
